import type {HardwareFastenerRequirement} from './types';

export function HardwareFastening({rows,quantity}:{rows:HardwareFastenerRequirement[];quantity:number}){
 if(!rows.length)return null;
 return <details className="measure-materials"><summary>Крепёж GEVISS по деталям · {rows.reduce((sum,row)=>sum+(row.knownFasteners??0),0)*quantity} известных креплений</summary>
  <p>Справочная норма, не дополнительные платные позиции. Крепёж KNM 737 и ручки, размеры винтов и состав упаковки ещё не подтверждены.</p>
  <ul>{rows.map(row=><li key={row.code}><b>{row.code}</b>: {row.partQuantity*quantity} шт. × {row.fastenersPerPart??'норма не указана'}{row.knownFasteners!==null?` = ${row.knownFasteners*quantity} креплений`:''}</li>)}</ul>
  <a href={rows[0].source} target="_blank" rel="noreferrer">Технический каталог GEVISS</a>
 </details>;
}
